<template>
    <b-card>
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">{{$t('facebook.connect_with_facebook_title')}}</h4>
            </div>
        </template>

        <div>{{statusText}}</div>

        <b-alert v-if="errorText" show variant="danger" class="mt-3 mb-0">
            {{ errorText }}
        </b-alert>

        <b-button
            v-if="showConnectButton"
            variant="primary"
            class="mt-3"
            :disabled="processing"
            @click="login"
        >
            {{ $t('facebook.connect_button') }}
        </b-button>
    </b-card>
</template>

<script>
import { initFacebookSdk } from "../service/facebookSdk";
import { storeTemporaryToken } from "@/modules/Integration/Facebook/repository";

export default {
    name: 'FanpageConnect',
    computed: {
        facebookSdkLocale() {
            const crmLocale = this.$i18n.locale
            return 'pl' === crmLocale ? 'pl_PL' : 'en_US'
        }
    },

    mounted() {
        this.appConfiguration.appId = this.$route.query.appId
        this.appConfiguration.appVersion = this.$route.query.appVersion
        this.appConfiguration.appScopes = this.$route.query.appScopes

        this.continueUrl = this.$route.query.continueUrl

        this.initFacebook()
    },

    data: () => ({
        appConfiguration: {
            appId: null,
            appVersion: null,
            appScopes: null
        },
        continueUrl: null,
        showConnectButton: false,
        processing: false,
        statusText: '',
        errorText: '',
    }),

    methods: {
        initFacebook() {
            this.showConnectButton = false
            this.statusText = this.$t('facebook.init_facebook_sdk')
            initFacebookSdk(
                this.appConfiguration.appId,
                this.appConfiguration.appVersion,
                this.facebookSdkLocale,
            ).then(() => {
                this.showConnectButton = true
                this.statusText = this.$t('facebook.connect_hint')
            })
        },
        login() {
            this.errorText = ''
            this.processing = true
            window.FB.login((response) => {
                if ('connected' === response.status && response.authResponse) {
                    this.successFullCallback(response.authResponse)
                } else {
                    this.processing = false
                    this.statusText = this.$t('facebook.login_error')
                }
            }, {
                scope: this.appConfiguration.appScopes,
                auth_type: 'rerequest',
                return_scopes: true,
            })
        },
        successFullCallback(authResponse) {
            this.statusText = this.$t('facebook.login_successful')
            this.showConnectButton = false
            storeTemporaryToken(authResponse)
                .then(({ data }) => {
                    const url = new URL(this.continueUrl);
                    url.searchParams.set('tokenUuid', data.uuid);
                    window.location.replace(url.toString());
                })
                .catch(() => {
                    this.errorText = this.$t('facebook.store_token_error')
                    this.statusText = ''
                    this.showConnectButton = true
                    this.processing = false
                })
        },
    }
}
</script>